<template>

<app-content :loading="is.loading && !is.initialised">

	<app-content-head :title="item.fullname" back="Conventions.Browse">

		<app-content-head-actions-item :disabled="!isDirty" icon="undo" text="Undo" v-on:click="onUndoClick" v-if="canEdit" />
		
		<app-content-head-actions-item :loading="is.saving" :disabled="!isDirty || !isValid" icon="save" text="Save" v-on:click="onSaveClick" v-if="canEdit" />
		
		<app-content-head-actions-item v-if="canDelete" :disabled="isNew" :danger="true" icon="delete" text="Delete" v-on:click="onDeleteClick" />

		<app-content-head-actions-item icon="admin.credit" :disabled="isDirty" text="Credit" tooltip="Issue credit to convention" v-on:click="onCreditClick" />

		<app-content-head-actions-item icon="admin.launch" text="Launch" tooltip="Launch convention as admin or attendee" v-on:click="onLaunchClick" />

	</app-content-head>

	<app-content-body :loading="is.loading && is.initialised">

		<app-content-summary>

			<app-content-summary-item :is-fixed="true" label="Status" :tag="$constants.convention.statusName[item.status]" :status="$constants.convention.statusTheme[item.status]" :theme="$constants.convention.statusTheme[item.status]" />
			
			<app-content-summary-item :is-fixed="true" label="Reference" :value="item.reference" />

			<app-content-summary-item :grow="true" label="Name" :value="item.fullname" />

			<app-content-summary-item :is-fixed="true" label="Starts" :value="item.date.start | localDate('MM/DD/YYYY')" />

			<app-content-summary-item :is-fixed="true" label="Ends" :value="item.date.end | localDate('MM/DD/YYYY')" />

			<app-content-summary-item label="Organization" :item="item.organisation" type="organisation" />

			<app-content-summary-item label="Owner" :item="item.user" type="user" />
			
		</app-content-summary>

		<app-content-summary>

			<app-content-summary-item :is-metric="true" :grow="true" :is-end="true" label="Badge" :value="item.count.badges.holders" alt="0" />

			<app-content-summary-item :is-metric="true" :grow="true" :is-start="true" label="Checkout" :value="item.count.checkout.loans.total" alt="0" />

			<app-content-summary-item :is-metric="true" :grow="true" label="Event" :value="item.count.schedule.events" alt="0" />

			<app-content-summary-item :is-metric="true" :grow="true" :is-end="true" label="Sale" :value="item.count.registration.sales" alt="0" />

			<app-content-summary-item :is-metric="true" :grow="true" :is-start="true" :no-plural="true" label="Revenue" :value="item.count.billing.sales_total | formatMoney" />

			<app-content-summary-item :is-metric="true" :grow="true" :no-plural="true" label="Refunds" :value="item.count.billing.refunds_total | formatMoney" />

			<app-content-summary-item :is-metric="true" :grow="true" :no-plural="true" label="Credits" :value="item.count.billing.credits_total | formatMoney" />

			<app-content-summary-item :is-metric="true" :grow="true" :is-end="true" :no-plural="true" label="Charges" :value="item.count.billing.platform_total | formatMoney" />

			<app-content-summary-item :is-metric="true" :grow="true" :is-start="true" :no-plural="true" label="Net Revenue" :value="item.count.billing.net_total | formatMoney" />
			
		</app-content-summary>

		<app-content-box :tabs="tabsSetup">

			<template v-slot:setup>

				<app-input-text :locked="!canEdit" label="Name" placeholder="Enter name" v-model="model.name" :textPrefix="item.organisation.name" :validation="$v.model.name" />
				
				<app-input-date :locked="!canEdit" label="Starts on" placeholder="Enter date" v-model="model.date.start" :validation="$v.model.date.start" />
				
				<app-input-toggle :locked="!canEdit" label="Duration" :fullWidth="true" v-model="duration" :options="durationOptions" />

			</template>

			<template v-slot:library>

				<app-input-toggle label="Type" v-model="model.permissions.library.rented" :options="libraryRentedOptions" />
				
				<app-input-select label="Collection" v-model="model.permissions.library.collection" placeholder="Entire library" :options="references.collections" v-if="model.permissions.library.rented" />

			</template>

			<template v-slot:credit>

				<com-credits :items="references.credits" v-on:cancel="onCancelCredit($event)" />

			</template>

		</app-content-box>

	</app-content-body>

	<com-credit v-if="is.crediting" v-on:close="is.crediting = false" :id="item.id" v-on:credited="onRefresh" />

	<com-launch v-if="is.launching" v-on:close="is.launching = false" :id="item.id" :organisation="item.organisation.id" />

	<com-confirm title="Remove credit" method="delete" v-if="is.uncrediting" :api="['conventions/convention', item.id, 'credit', is.uncrediting.id]" v-on:confirmed="onCancelledCredit" v-on:close="is.uncrediting = false">

		Are you sure you wish to remove the credit <b>{{ is.uncrediting.title }}</b> of {{ is.uncrediting.amount | formatMoney }}?

	</com-confirm>

</app-content>

</template>

<script>

import mixForm from '@/mixin/form'

import comConfirm from './common/panel/Confirm'
import comLaunch from './conventionsconvention/Launch'
import comCredit from './conventionsconvention/Credit'
import comCredits from './conventionsconvention/Credits'

export default {

	mixins: [mixForm],

	components: {
		'com-confirm': comConfirm,
		'com-launch': comLaunch,
		'com-credit': comCredit,
		'com-credits': comCredits
	},

	data: function() {

		return {
			is: {
				crediting: false,
				uncrediting: false,
				launching: false
			},
			references: {
				collections: [],
				credits: []
			},
			libraryRentedOptions: {
				0: 'Own',
				1: 'DTW'
			},
			durationOptions: {
				1: '1 day',
				2: '2 days',
				3: '3 days',
				4: '4 days',
				5: '5 days',
				6: '6 days',
				7: '7 days'
			},
			model: {
				id: false,
				name: '',
				date: {
					start: 0,
					end: 0
				}
			},
			duration: 0
		}

	},

	validations: {
		model: {
			date: {}
		}
	},

	computed: {

		tabsSetup: function() {
		
			return [
				{ name: 'setup', text: 'Setup' },
				{ name: 'library', text: 'Library' },
				{ name: 'credit', text: 'Credits', count: this.item.count.billing.credits_received, notPadded: true }
			]

		},
	
		canEdit: function() {
		
			return this.$_.contains([
				this.$constants.convention.status.setup,
				this.$constants.convention.status.active,
			], this.item.status)
		
		},
	
		canDelete: function() {
		
			return this.$_.contains([
				this.$constants.convention.status.setup,
				this.$constants.convention.status.cancelled
			], this.item.status)
		
		}

	},

	watch: {

		duration: function() {

			this.model.date.end = this.model.date.start + (this.duration * 86400)

		}

	},

	methods: {

		onModelUpdate: function() {

			this.duration = Math.ceil((this.model.date.end - this.model.date.start) / 86400)

		},

		onCancelledCredit: function() {
		
			this.is.uncrediting = false 

			this.onRefresh()

		},

		onCancelCredit: function(e) {
		
			this.is.uncrediting = e

		},

		onCreditClick: function() {
		
			this.is.crediting = true

		},

		onLaunchClick: function() {
		
			this.is.launching = true

		}
		
	}

}

</script>

<style scoped>

</style>